var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconChevronRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 9,
    viewBox: "0 0 6 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "angle-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.24983 8.74996C1.14912 8.74657 1.05016 8.72265 0.959027 8.67966C0.867891 8.63667 0.786495 8.57552 0.719829 8.49996C0.579378 8.35934 0.500488 8.16871 0.500488 7.96996C0.500488 7.77121 0.579378 7.58059 0.719829 7.43996L3.71983 4.43996L0.719829 1.43996C0.660505 1.29595 0.647487 1.13704 0.682583 0.985298C0.717679 0.833552 0.799147 0.696496 0.915679 0.593157C1.03221 0.489817 1.17802 0.425321 1.33288 0.408621C1.48773 0.391921 1.64394 0.423846 1.77983 0.499964L5.27983 3.99996C5.42028 4.14059 5.49917 4.33121 5.49917 4.52996C5.49917 4.72871 5.42028 4.91934 5.27983 5.05996L1.77983 8.49996C1.71316 8.57552 1.63177 8.63667 1.54063 8.67966C1.44949 8.72265 1.35054 8.74657 1.24983 8.74996Z",
    fill: "#F8F9FA"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronRight);
export default __webpack_public_path__ + "static/media/icon-chevron-right.85c9ae04941f14fd46c60dff92311002.svg";
export { ForwardRef as ReactComponent };